import React from 'react';
import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Main from "./components/Main/Main";
import Token from "./components/Main/Token";
import {BrowserRouter as Router, Route} from "react-router-dom";
import {ToastProvider} from 'react-toast-notifications'

require('dotenv').config();
//https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appId=Bh5WbbzNnpYVcubwaeIXjRMWA3fB3eBQP9F6WHa0Kco1&redirectUrl=wms.e-synergi.dk%2Fintegration%2Fwebconfig%3Fid%3D553%26page%3D1
const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATCH;

function App() {

    return (
        <ToastProvider>
            <Router>
                <switch>
                    <Route exact path={`${PUBLIC_PATH}/`} component={Token}/>
                    <Route path={`${PUBLIC_PATH}/main`} component={Main}/>
                </switch>
            </Router>
        </ToastProvider>
    );
}


export default App;
